import {CalendarToday} from "@mui/icons-material";
import {SxProps, Theme} from "@mui/material";
export const commonTextFieldProps: SxProps<Theme> = {
    "& .MuiInputBase-root": {
        minHeight: "44px", // Ensures proper height for single-line input
        borderRadius: "6px",
    },
    "& .MuiOutlinedInput-root": {
        alignItems: "flex-start", // Aligns text to the top for multiline
        //padding: '10px', // Adds padding inside the input
    },
    "& .MuiOutlinedInput-notchedOutline": {
        border: (theme) => `1px solid ${theme.palette.text.secondary}`,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: (theme) => `1px solid #123257`,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "1px solid #123257",
    },
    "& .MuiInputBase-input": {
        color: "#6d87aa",
        padding: "12px", // Adjust padding for better spacing
    },
    "& .MuiInputBase-inputMultiline": {
        padding: "0px", // Adjust padding for better spacing
        margin: 0,
        lineHeight: 1, // Adjusts line height for better readability
    },
    "& .MuiInputLabel-root": {
        fontSize: "0.875rem",
        top: "-4px",
    },
    "& .MuiSelect-icon": {
        color: (theme) => theme.palette.secondary.main,
    },
    '& input[type="date"]::-webkit-calendar-picker-indicator': {
        filter: "invert(35%) sepia(92%) saturate(678%) hue-rotate(-30deg)",
        cursor: "pointer",
    },
    "& .MuiFormLabel-asterisk": {
        color: (theme) => theme.palette.error.main,
    },
};

// sx={{
//   ...commonTextFieldProps,
//   margin: 0,
// }}
// slotProps={{

//   textField: {
//     fullWidth: true,
//     error: !!errors.birthDate,
//     helperText: errors.birthDate?.message,
//   },
//   openPickerButton: {
//     sx: {
//       mt: "12px",
//       color: "secondary.main",
//       display: "flex", // Ensures proper alignment
//       alignItems: "center", // Vertically centers the icon
//       justifyContent: "center", // Horizontally centers the icon
//       "& .MuiSvgIcon-root": {
//         fontSize: "20px",
//       },
//     },
//   },
// }}
// slots={{
//   openPickerIcon: CalendarToday, // Change the default calendar icon
// }}

export const datePickerProps = (errors: any, isMissingDetails?: boolean) => ({
    sx: {
        ...commonTextFieldProps,
        margin: 0,
    },
    slotProps: {
        textField: {
            fullWidth: true,
            error: !!errors?.birthDate || isMissingDetails,
            helperText: errors?.birthDate?.message ?? (isMissingDetails ? "Select Birthday" : ""),
        },
        openPickerButton: {
            sx: {
                mt: "12px",
                color: "secondary.main",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& .MuiSvgIcon-root": {
                    fontSize: "20px",
                },
            },
        },
    },
    slots: {
        openPickerIcon: CalendarToday, // Custom calendar icon
    },
});
